import { render } from "./SpaymentReceiptsIndex.vue?vue&type=template&id=081870b7&scoped=true"
import script from "./SpaymentReceiptsIndex.vue?vue&type=script&lang=js"
export * from "./SpaymentReceiptsIndex.vue?vue&type=script&lang=js"

import "./SpaymentReceiptsIndex.vue?vue&type=style&index=0&id=081870b7&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081870b7"]])

export default __exports__